const { createApp, ref, component, watch, onMounted, reactive, onBeforeMount, onUnmounted } = Vue;
let currentGeoloc = null;

const paymentOptionsApp = createApp({
	name: "PaymentOptionsApp",
	setup() {
		const paymentOptionsData = ref(paymentOptionsDataObj);
		const isLoading = ref(false);
		const AtcPayload = ref([]);
		const isSubmitting = ref(false);
		const currentActiveBlock = ref('');
		const doesSubAdnExist = ref(false);
		const addOnQty = ref(1);
		const redirectToCheckout = ref(false);
		const eventsAttachedToAtc = ref(false);
		const redirectToLp = ref(null);
		const currentMainProductVarId = ref(null);
		let variantInputEl = null;

		// window.mainProductPrice = {
		// 	"discount_price": "17997.0",
		// 	"sale_price": "29995",
		// 	"savings": "40%"
		// }

		onMounted(async () => {
			isLoading.value = true;
			let paymentBlocks = paymentOptionsData.value.blocks;
			renderAdditionalTagOrPriceOnMount(paymentOptionsData.value.blocks);
			await Promise.all(
				paymentBlocks.map(async (pb) => {
					if (pb.type === 'free_with_subscription' || pb.type === 'pay_in_full') {
						pb.add_ons = await Promise.all(pb.add_ons.map(async (a) => {
							if (!a.hidden) {
								a.products = await Promise.all(
									a.products.map(async (p) => {
										const sellingPlan = p.selling_plan_allocations[0].selling_plan;
										//checking if selling plan belongs to OG
										if(sellingPlan.name.includes('Delivered')) {
											console.log("[zeroValuePlan1]", zeroValuePlan, sellingPlanDiscount, p.name);
											let ogInfo = await getOGSellingPlans(p.id);
											let incentiveGroup = ogInfo.groups.find(group => group.group_type === "incentive");
											p.og_selling_plan_id = getOGActiveSellingPlan(p.selling_plan_allocations, pb.sale_price)
											// og discount fallback
											p.og_discount = 20;
											if (incentiveGroup && parseInt(incentiveGroup?.name?.split("-")[0]) !== 0) {
												p.og_discount = parseInt(incentiveGroup.name.split("-")[0]);
											}
											p.price_info = calculateDiscount(p);
											return p;
										} else {
											p.og_selling_plan_id = getOGActiveSellingPlan(p.selling_plan_allocations, pb.sale_price)
											// if selling plan belong to Recharge, get discount value from selling plan object
											if(pb.sale_price == "100.0") {
												const zeroValuePlan  = p.selling_plan_allocations.find(plan => {
													return plan.selling_plan.price_adjustments[0].value == 0
												});
												const sellingPlanDiscount = zeroValuePlan ? zeroValuePlan.selling_plan.price_adjustments[0].value : 0
												p.og_discount = sellingPlanDiscount;
												p.price_info = calculateDiscount(p);
												console.log("[zeroValuePlan2]", zeroValuePlan, sellingPlanDiscount, p.name);
												return { ...p };
											} else {
												const sellingPlanDiscount  = sellingPlan.price_adjustments[0].value;
												p.og_discount = sellingPlanDiscount;
												p.price_info = calculateDiscount(p);
												return { ...p };
											}
										}
									})
								);
							}
							return a;
						}));
					}
					return pb;
				})
			);
			paymentOptionsData.value.blocks = paymentBlocks;
			await loadCurrentLocation();
			variantInputEl = document.querySelector("input[name='id']").value;
			currentMainProductVarId.value = variantInputEl ? variantInputEl : null;
			isLoading.value = false;
		});

		function getOGActiveSellingPlan(plans, salePrice) {
			let og_selling_plan_id = null;
			for (let i = 0; i < plans.length; i++) {
				let sellingPlanAllocation = plans[i];
				let sellingPlan = sellingPlanAllocation.selling_plan;

				if(salePrice == "100.0") {
					if(sellingPlan.price_adjustments[0].value == 0) {
						og_selling_plan_id = sellingPlan.id;
					}
				} else {
					if(sellingPlan.price_adjustments[0].value > 0 && sellingPlan.name.includes('30')) {
						og_selling_plan_id = sellingPlan.id;
						break; // exit the loop
					}
				}

			}
			return og_selling_plan_id;
		}

		onBeforeMount(() => {
			document.addEventListener('variant:change', () => {
				const variantId = document.querySelector("input[name='id']").value
				currentMainProductVarId.value = variantId ? variantId : null;
				if(currentActiveBlock.value === ''){
					setTimeout(()=>{
						updateMainProductLinePrice({ sale_price: window.mainProductPrice.sale_price, discount_price: window.mainProductPrice.discount_price, savings: window.mainProductPrice.savings }, undefined);
					},10);
				}
			});
			reHookEventsOnAtcBtn();
		});

		function loadCurrentLocation() {
			return new Promise((resolve, reject) => {
			  if (typeof Rebuy !== 'undefined' && Rebuy._status === 'initialized' && typeof Rebuy.getGeolocation === 'function') {
				Rebuy.getGeolocation().then(resp => {
				  currentGeoloc = resp;
				  resolve(currentGeoloc);
				}).catch(error => {
				  reject(error);
				});
			  } else {
				setTimeout(() => {
				  loadCurrentLocation().then(resolve).catch(reject);
				}, 50);
			  }
			});
		}

		watch(currentActiveBlock, () => {
			AtcPayload.value = [];
		});

		watch(AtcPayload, () => {
			doesSubAdnExist.value = AtcPayload.value.some((p) => p.selling_plan);
		});

		watch(isSubmitting, () => handleATCLoading());

		function reHookEventsOnAtcBtn() {
			try {
				const mutationHandler = function (mutationsList, observer) {
					for (let mutation of mutationsList) {
						if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
							let atcBtn = document.querySelector("#AddToCart button");
							// Check if the "AddToCart" button is now in the DOM
							if (atcBtn === mutation.target) {
								observer.disconnect();
								////console.log('mutation running');
								let clonedAtcBtn = atcBtn.cloneNode(true);
								clonedAtcBtn.setAttribute('type', 'button');
								atcBtn.parentNode.replaceChild(clonedAtcBtn, atcBtn);
								clonedAtcBtn.addEventListener('click', handleAddToCart);
								// reHookEventsOnQtyBtns();
								eventsAttachedToAtc.value = true;
							}
						}
					}
				};
				const observer = new MutationObserver(mutationHandler);
				observer.observe(document.body, { childList: true, subtree: true });
			} catch (error) {
				//console.log(error);
			}
		}

		function reHookEventsOnQtyBtns() {
			let qtySelector = document.querySelector('quantity-selector.quantity-selector');
			if (qtySelector) {
				let qtySelectorBtns = qtySelector.querySelectorAll('button.quantity-selector__button');
				qtySelectorBtns[0].addEventListener('click', () => handleQtySelect('-'));
				qtySelectorBtns[1].addEventListener('click', () => handleQtySelect('+'));
				document.querySelector('quantity-selector input.quantity-selector__input').style['pointer-events'] = 'none';
			}
		}

		function handleQtySelect(action) {
			if (action === '+') {
				addOnQty.value = addOnQty.value + 1;
			}

			if (action === '-') {
				addOnQty.value = addOnQty.value > 1 ? addOnQty.value + 1 : addOnQty.value - 1;
			}
		}

		function handleATCLoading() {
			let atcBtn = document.querySelector("#AddToCart button");
			if (isSubmitting.value) {
				atcBtn.setAttribute('aria-busy', true);
				atcBtn.setAttribute('disabled', true);
			} else {
				atcBtn.removeAttribute('aria-busy');
				atcBtn.removeAttribute('disabled');
			}
		}

		async function handleAddToCart() {
			if (redirectToLp.value) {
				window.location.href = redirectToLp.value;
				return;
			}
			isSubmitting.value = true;
			let properties = {}
			// getting the lineitem property from the current active payment block
			const lineItemProperty = paymentOptionsData.value.blocks.find(b => b.id === currentActiveBlock.value)?.line_item_property;
			const bundleIdProperty = paymentOptionsData.value.blocks.find(b => b.id === currentActiveBlock.value)?.bundle_id;
			if (lineItemProperty) {
				properties[lineItemProperty] = true;
			}

			if(bundleIdProperty){
				const uniqueId = [bundleIdProperty,currentMainProductVarId.value];
				AtcPayload.value.forEach(p => {
					uniqueId.push(p.id);
				});
				properties['_bundle_id'] = uniqueId.join("_");				
			}

			try {
				let mainProduct = {
					quantity: addOnQty.value,
					id: parseInt(currentMainProductVarId.value),
					properties
				};
				let atcProducts = AtcPayload.value.map(p => {
					return {
						...p,
						quantity: addOnQty.value,
						properties
					}
				});
				const widget = window.Rebuy.widgets.find(widget => widget.id === "52434");
				if (widget && atcProducts.length) {
					widget.detachWidget()
				}
				//console.log({mainProduct, atcProducts },"add to cart working");
				if (redirectToCheckout.value) Rebuy.SmartCart.skip_open = true;
				const response = await fetch(window.Shopify.routes.root + "cart/add.js", {
					method: "POST",
					headers: {
						"Content-Type": "application/json",
					},
					body: JSON.stringify({ items: [mainProduct, ...atcProducts] }),
				})
				const data = await response.json();
				if (data && redirectToCheckout.value) {
					let str = window.location.href.includes("/es/") ? "?locale=es" : "";
					str = "/checkout" + str;
					window.location.href = str;
				}
			} catch (error) {
				//console.log(error);
			} finally {
				isSubmitting.value = false;
			}
		}

		async function getOGSellingPlans(productId) {
			try {
				let resp = await fetch(
					`https://us-central1-shopify-web-dev.cloudfunctions.net/getOGIncentive?productId=${productId}`,
					{
						method: "GET",
					}
				);
				return resp.json();
			} catch (error) {
				//console.log(error);
			}
		}

		function handleBlockSelect(e, checkout_label, checkout_redirect, isOos, landing_page_redirect) {
			currentActiveBlock.value = e;
			let atcBtn = document.querySelector("#AddToCart button");
			let atcBtnInrTxt = atcBtn;
			atcBtn.classList.remove("sold-out");
			atcBtn.removeAttribute("disabled");
			if (checkout_label !== undefined && checkout_label !== null && checkout_label !== "") {
				atcBtnInrTxt.textContent = checkout_label;
				// updating this attribute will prevent default behivour of theme to update the button text based on variant change
				atcBtn.setAttribute("data-button-content", checkout_label);
			}
			if (checkout_redirect !== undefined && checkout_redirect !== null && checkout_redirect !== "") {
				redirectToCheckout.value = checkout_redirect;
			}

			redirectToLp.value = null;
			if (landing_page_redirect && typeof landing_page_redirect === 'string') {
				redirectToLp.value = landing_page_redirect;
			}

			if (typeof isOos === "boolean" && isOos || !checkMainProductAvailablility()) {
				atcBtnInrTxt.textContent = "Out of Stock";
				atcBtn.setAttribute("data-button-content", "Out of Stock");
				atcBtn.classList.add("sold-out");
				atcBtn.setAttribute("disabled", '');
			}
		}


		function checkMainProductAvailablility(){
			let selectedVariantId = currentMainProductVarId.value;
			const filteredMainProdVariant = paymentOptionsData.value.main_product.variants.find(item => item.id === +selectedVariantId);
			return filteredMainProdVariant ? filteredMainProdVariant.available : false;
    }
    
		function handleBlockUnSelect(e){
			try {
				if(paymentOptionsData.value.block_input_type === 'checkbox'){
					let atcBtn = document.querySelector("#AddToCart button");					
					currentActiveBlock.value = '';
					atcBtn.textContent = "ADD TO CART";
					atcBtn.setAttribute("data-button-content", "ADD TO CART");
					if(redirectToLp.value){
						redirectToLp.value = null;
					}
					updateMainProductLinePrice(
						{
							sale_price: window.mainProductPrice.sale_price,
							discount_price: window.mainProductPrice.discount_price,
							savings: window.mainProductPrice.savings,
						},
						undefined
					);
					renderAdditionalTagOrPriceOnMount(paymentOptionsData.value.blocks);
				}				
			} catch (error) {
				console.error(error);
			}
		}

		function handeLineItemDispatch(e) {
			AtcPayload.value = e;
		}

		function hasBlackListedVariant(blackList=[],blockType){
			//console.log("has block variant",blockType);
			if(blackList && blackList.length && blackList.includes(currentMainProductVarId.value)){
				//console.log(currentMainProductVarId.value,"current variant product id");
				if(blockType === currentActiveBlock.value){
					currentActiveBlock.value = "";
					const currentVariant = paymentOptionsData.value.main_product.variants.find(v=>v.id === parseInt(currentMainProductVarId.value));
					handleBlockSelect("","ADD TO CART",false,!currentVariant.available,undefined);
					updateMainProductLinePrice({ sale_price: window.mainProductPrice.sale_price, discount_price: window.mainProductPrice.discount_price, savings: window.mainProductPrice.savings }, blockType);
				}
				return true;
			}
			return false;
		}
		

		return {
			paymentOptionsData,
			isLoading,
			currentActiveBlock,
			hasBlackListedVariant,
			shouldRenderBlock,
			handleBlockSelect,
			handleBlockUnSelect,
			handeLineItemDispatch,
			checkMainProductAvailablility,
			currentMainProductVarId,
			AtcPayload,
			addOnQty,
			doesSubAdnExist,
			eventsAttachedToAtc
		}
	},
	delimiters: ["${", "}"]
});

paymentOptionsApp.component('pb-free-w-subscription', {
	template: "#freeWSubscription",
	emits: ["on-block-select", "on-line-item-dispatch","on-block-unselect"],
	props: ['block_data', 'block_active', 'is_preselected', 'payment_options_data','input_type'],
	setup(props, ctx) {
		const doesSubAdnExist = ref(false);
		const isOutOfStock = ref(false);
		const blockAddOnState = ref(props.block_data.add_ons.filter(a => !a.hidden).map(a => {
			return {
				id: a.id,
				data: []
			}
		}));

		const blockHiddenAddOnState = ref(props.block_data.add_ons.filter(a => a.hidden).map(a => {
			return a.products;
		}).flat());

		watch(() => props.block_active, () => {
			if (!props.block_active) {
				doesSubAdnExist.value = false;
			}
		});

		watch(blockAddOnState, () => {
			if (props.block_active) dispatchLineItems();
			doesSubAdnExist.value = blockAddOnState.value.map(a => a.data).flat().some((p) => p.purchase_type === "SUBSCRIPTION");
		});

		onMounted(() => {
			isOutOfStock.value = props.block_data.add_ons.map(a => {
				return a.product || a.products
			}).flat().some(p => p.availble === false);
			document.addEventListener('variant:change', () => {
				if (props.block_active) {
					ctx.emit("on-block-select", props.block_data.id, props.block_data.add_to_cart_label, props.block_data.redirect_to_checkout, isOutOfStock.value);
				}
			});
			if (props.is_preselected) {
				////console.log(props.is_preselected,"preselected");
				ctx.emit("on-block-select", props.block_data.id, props.block_data.add_to_cart_label, props.block_data.redirect_to_checkout, isOutOfStock.value);
				handeFreeWSubBlockPriceUpdate();
			}
		});

		function dispatchLineItems() {
			let cartPayload = blockAddOnState.value.map((a) => {
				return a.data.map(p => {
					let lineItem = {

						id: p.variant_id,
					};
					if (p.purchase_type === "SUBSCRIPTION") {
						lineItem.selling_plan = parseInt(p.selling_plan_id);
					}
					return lineItem;
				})
			}).flat();
			let hiddenProducts = blockHiddenAddOnState.value.map((p) => {
				return {
					id: p.id,
				};
			});
			cartPayload = [...cartPayload, ...hiddenProducts];
			ctx.emit('on-line-item-dispatch', cartPayload);
		}

		function handleBlockEnable(e) {
			if(!e.target.checked){				
				ctx.emit("on-block-unselect",null);
			}else{
				ctx.emit("on-block-select", props.block_data.id, props.block_data.add_to_cart_label, props.block_data.redirect_to_checkout, isOutOfStock.value);
			}	
		}

		function handleAddOnDisabled(e) {
			blockAddOnState.value = blockAddOnState.value.map(a => {
				if (a.id === e.id) {
					return { ...e, data: [] };
				}
				return a;
			});
		}

		function handleAddOnSelect(e) {
			blockAddOnState.value = blockAddOnState.value.map(a => {
				if (a.id === e.id) {
					return e;
				}
				return a;
			});
		}

		function handeGiftAddOn(e) {
			blockAddOnState.value = blockAddOnState.value.map(a => {
				if (a.id === e.id) {
					return e;
				}
				return a;
			});
		}

		function handleAddOnUpdate(e) {
			blockAddOnState.value = blockAddOnState.value.map(a => {
				if (a.id === e.id) {
					return {
						...a,
						data: a.data.map(p => {
							if (p.variant_id === e.variant_id) {
								return {
									...p,
									purchase_type: e.purchase_type
								}
							}
							return p;
						})
					};
				}
				return a;
			});
		}

		return {
			doesSubAdnExist,
			blockAddOnState,
			blockHiddenAddOnState,
			handleBlockEnable,
			formatMoneyy,
			calculateDiscountedPrice,
			handleAddOnDisabled,
			handleAddOnSelect,
			handleAddOnUpdate,
			handeGiftAddOn
		}
	},
	delimiters: ["${", "}"]
});

paymentOptionsApp.component('pb-pay-in-full', {
	template: "#payInFullBlock",
	emits: ["on-block-select", "on-line-item-dispatch", "on-block-unselect"],
	props: ['block_data', 'block_active', 'is_preselected', 'payment_options_data', 'input_type'],
	setup(props, ctx) {
		const doesSubAdnExist = ref(false);
		const isOutOfStock = ref(false);
		const blockAddOnState = ref(props.block_data.add_ons.filter(a => !a.hidden).map(a => {
			return {
				id: a.id,
				data: []
			}
		}));
		const headerBlockPrice = ref({
			sale_price: 0,
			discount_price: 0,
			savings: []
		});
		const discountForMainProductFrmAdnArr = ref(initBlockHeaderDiscount());
		const blockHiddenAddOnState = ref(props.block_data.add_ons.filter(a => a.hidden).map(a => {
			return a.products;
		}).flat());

		// watcher callback runs on when block selected/unselected
		watch(() => props.block_active, () => {
			if (!props.block_active) {
				doesSubAdnExist.value = false;
				// reset block head price to default state
				discountForMainProductFrmAdnArr.value = initBlockHeaderDiscount();
				blockAddOnState.value = blockAddOnState.value.map(a => ({ ...a, data: [] }));
			} else {
				updateBlockHeaderPriceInfo();
			}
		});

		watch(blockAddOnState, () => {
			if (props.block_active) {
				dispatchLineItems();
				// update the addon discount on addon state changes when current block is active
				discountForMainProductFrmAdnArr.value = discountForMainProductFrmAdnArr.value.map(d => {
					let activeAdn = blockAddOnState.value.find(b => b.id === d.id);
					if (activeAdn.data.length && activeAdn.data[0].purchase_type === 'SUBSCRIPTION' && (activeAdn.data[0]?.enable_discount === 'SUBSCRIPTION' || activeAdn.data[0]?.enable_discount === 'BOTH')) {
						return {
							id: d.id,
							discount_value: parseFloat(activeAdn.data[0].subscription_discount_value),
							discount_value_type: activeAdn.data[0].subscription_discount_value_type
						}
					}
					if (activeAdn.data.length && activeAdn.data[0].purchase_type === 'ONE_TIME' && (activeAdn.data[0]?.enable_discount === 'ONE_TIME' || activeAdn.data[0]?.enable_discount === 'BOTH')) {
						return {
							id: d.id,
							discount_value: parseFloat(activeAdn.data[0].one_time_discount_value),
							discount_value_type: activeAdn.data[0].one_time_discount_value_type
						}
					}

					return {
						id: d.id,
						discount_value: 0,
						discount_value_type: 'PERCENTAGE'
					}
				});
			}
			doesSubAdnExist.value = blockAddOnState.value.map(a => a.data).flat().some((p) => p.purchase_type === "SUBSCRIPTION");
			updateBlockHeaderPriceInfo();
		});

		onMounted(() => {
			updateBlockHeaderPriceInfo();
			isOutOfStock.value = props.block_data.add_ons.map(a => {
				return a.product || a.products
			}).flat().some(p => p.availble === false);
			document.addEventListener('variant:change',variantChangedHandler);
			if (props.is_preselected) {
				////console.log(props.is_preselected,"preselected");
				ctx.emit("on-block-select", props.block_data.id, props.block_data.add_to_cart_label, props.block_data.redirect_to_checkout, isOutOfStock.value);
			}
			// updateTopLinePrice();
		});

		function variantChangedHandler(){
			if (props.block_active) {
			  ctx.emit("on-block-select", props.block_data.id, props.block_data.add_to_cart_label, props.block_data.redirect_to_checkout, isOutOfStock.value);
			  updateBlockHeaderPriceInfo();
			}
		};
		  

		onUnmounted(()=>{
			document.removeEventListener('variant:change',variantChangedHandler);
		});

		function updateBlockHeaderPriceInfo() {
			const overidePrice = parseFloat(props.block_data.original_price) * 100 || 0;
			const overideSalePriceDiscount = parseFloat(props.block_data.sale_price) || 0;
			const priceRenderMode = props.block_data.price_render_mode;
			// getting top line price from global context.
			let salePrice = parseFloat(window.mainProductPrice.sale_price) || 0;
			let discountPrice = window.mainProductPrice.discount_price
				? parseFloat(window.mainProductPrice.discount_price)
				: null;
			let saveLabel = [formatSavingsLabel(window.mainProductPrice.savings)];
			// overide product price
			if (overidePrice) {
				salePrice = overidePrice;
			}
			if (overideSalePriceDiscount) {
				discountPrice = calculateDiscountedPrice(salePrice, overideSalePriceDiscount);
				saveLabel = [formatSavingsLabel(overideSalePriceDiscount)];
				//console.log(discountPrice,overideSalePriceDiscount,saveLabel,"discount from pay in full overide");
			}

			let addOnTotalDiscount = calculateTotalAdnDiscount(discountForMainProductFrmAdnArr.value, salePrice);
			//console.log(addOnTotalDiscount,"addon total discount");
			discountPrice = calculateDiscountedPrice(salePrice, addOnTotalDiscount);
			if (addOnTotalDiscount) saveLabel = [formatSavingsLabel(addOnTotalDiscount)];
			//console.log(addOnTotalDiscount,discountPrice,saveLabel,"add on total discount and price");
			// if there is no addon discount fallback to default discount
			if (!addOnTotalDiscount) {
				discountPrice = window.mainProductPrice.discount_price
					? parseFloat(window.mainProductPrice.discount_price)
					: null;
				if (overideSalePriceDiscount) {
					discountPrice = calculateDiscountedPrice(salePrice, overideSalePriceDiscount);
					saveLabel = [formatSavingsLabel(overideSalePriceDiscount)];
				}
				//console.log(discountPrice,overideSalePriceDiscount,saveLabel,"inside if there is no discount fallback");
			}

			// check if combined price is enabled if true then add the oil price with the main product price.
			if (priceRenderMode === "DISPLAY_COMBINED_PRICE") {
				// format the existing product label according to combined price.
				// *** the line bellow was temporary disabled until we figure out whats best.
				// if (addOnTotalDiscount) saveLabel = [`${addOnTotalDiscount.toFixed(2)}% OFF ${props.block_data.parent_product.title}`];

				if (addOnTotalDiscount) {
					saveLabel = [`${addOnTotalDiscount.toFixed(2)}% OFF ${props.block_data.parent_product.title}`];
				} else {
					saveLabel = [`${window?.mainProductPrice?.savings} OFF ${props.block_data.parent_product.title}`];
				}

				let { totalSalePrice, totalDiscountPrice } = getTotalAddonPrice(blockAddOnState.value);
				if (!totalSalePrice && !totalDiscountPrice) {
					const tempAddOnState = props.block_data.add_ons
						.filter((a) => !a.hidden)
						.map((a) => {
							const tempProduct = getTempProductSelection(a);
							return {
								id: a.id,
								data: [tempProduct],
							};
						});
					({ totalSalePrice, totalDiscountPrice } = getTotalAddonPrice(tempAddOnState));
				}

				salePrice = salePrice + totalSalePrice;
				//console.log(discountPrice, totalDiscountPrice, totalSalePrice, "discount", "addon discount", "total sale price");
				if (discountPrice != null && totalDiscountPrice) {
					discountPrice = discountPrice + totalDiscountPrice;
				} else if (!discountPrice && totalDiscountPrice) {
					discountPrice = Math.abs(salePrice - totalDiscountPrice);
				} else if (discountPrice != null && !totalDiscountPrice) {
					discountPrice = discountPrice + totalSalePrice;
				}

				headerBlockPrice.value.sale_price = salePrice;
				headerBlockPrice.value.discount_price = discountPrice;
				// updating label from addons when combined price is enabled.
				saveLabel = getSavingsLabelForAddons(saveLabel, blockAddOnState.value);
				saveLabel = renderAdditionalPromoLabelOrPrice(saveLabel, blockAddOnState.value, props.block_data);
				headerBlockPrice.value.savings = saveLabel;
				if (props.block_active) {
					updateMainProductLinePrice(headerBlockPrice.value, props.block_data.type);
				}
			} else if (priceRenderMode === "DISPLAY_COMBINED_PRICE_W_DISCOUNT") {
				let totalCombinedDiscount = null;
				saveLabel = [];
				let { totalSalePrice, totalDiscountPrice } = getTotalAddonPrice(blockAddOnState.value);
				if (!totalSalePrice && !totalDiscountPrice) {
					const tempAddOnState = props.block_data.add_ons
						.filter((a) => !a.hidden)
						.map((a) => {
							const tempProduct = getTempProductSelection(a);
							return {
								id: a.id,
								data: [tempProduct],
							};
						});
					({ totalSalePrice, totalDiscountPrice } = getTotalAddonPrice(tempAddOnState));
				}

				salePrice = salePrice + totalSalePrice;
				// console.log(discountPrice, totalDiscountPrice, totalSalePrice, "discount", "addon discount", "total sale price");
				if (discountPrice != null && totalDiscountPrice) {
					discountPrice = discountPrice + totalDiscountPrice;
				} else if (!discountPrice && totalDiscountPrice) {
					discountPrice = Math.abs(salePrice - totalDiscountPrice);
				} else if (discountPrice != null && !totalDiscountPrice) {
					discountPrice = discountPrice + totalSalePrice;
				}

				headerBlockPrice.value.sale_price = salePrice;
				headerBlockPrice.value.discount_price = discountPrice;
				totalCombinedDiscount = calculateDiscountPercentage(salePrice, discountPrice);
				// updating label from addons when combined price is enabled.
				if (totalCombinedDiscount) {
					saveLabel = [`${formatSavingsLabel(totalCombinedDiscount)}`];
					saveLabel = renderAdditionalPromoLabelOrPrice(saveLabel, blockAddOnState.value, props.block_data);
				}

				headerBlockPrice.value.savings = saveLabel;
				if (props.block_active) {
					updateMainProductLinePrice(headerBlockPrice.value, props.block_data.type);
				}
			} else if (priceRenderMode === "DISPLAY_ADD_ON_PRICE") {
				let { totalSalePrice, totalDiscountPrice } = getTotalAddonPrice(blockAddOnState.value);
				if (!totalSalePrice && !totalDiscountPrice) {
					const tempAddOnState = props.block_data.add_ons
						.filter((a) => !a.hidden)
						.map((a) => {
							const tempProduct = getTempProductSelection(a);
							return {
								id: a.id,
								data: [tempProduct],
							};
						});
					({ totalSalePrice, totalDiscountPrice } = getTotalAddonPrice(tempAddOnState));
				}
				headerBlockPrice.value.sale_price = totalSalePrice;
				headerBlockPrice.value.discount_price = totalDiscountPrice || null;

				//Update the main product price with discounts
				if (props.block_active) {
					updateMainProductLinePrice(
						{
							sale_price: salePrice,
							discount_price: discountPrice,
							savings: renderAdditionalPromoLabelOrPrice(saveLabel, blockAddOnState.value, props.block_data),
						},
						props.block_data.type
					);
				}
			} else if (priceRenderMode === "DISPLAY_MAIN_PRODUCT_PRICE") {
				headerBlockPrice.value.sale_price = salePrice;
				headerBlockPrice.value.discount_price = discountPrice;
				saveLabel = renderAdditionalPromoLabelOrPrice(saveLabel, blockAddOnState.value, props.block_data);
				headerBlockPrice.value.savings = saveLabel;
				if (props.block_active) {
					updateMainProductLinePrice(headerBlockPrice.value, props.block_data.type);
				}
			}
		}

		function getTempProductSelection(addOn) {
			const firstAvailableProduct = addOn.products.find(p => p.available);
			firstAvailableProduct.purchase_type = addOn.default_purchase_type;
			return firstAvailableProduct;
		}

		/**
		 * Returns the default block header discount can be used on block active/inactive
		 * @returns {object} default block header discount array
		 */
		function initBlockHeaderDiscount() {
			return props.block_data.add_ons.map(a => {
				if (a.default_purchase_type === 'SUBSCRIPTION' && a.enable_discount === 'SUBSCRIPTION' || a.enable_discount === 'BOTH') {
					return {
						id: a.id,
						discount_value: parseFloat(a.subscription_discount_value),
						discount_value_type: a.subscription_discount_value_type
					}
				}
				if (a.default_purchase_type === 'ONE_TIME' && a.enable_discount === 'ONE_TIME' || a.enable_discount === 'BOTH') {
					return {
						id: a.id,
						discount_value: parseFloat(a.one_time_discount_value),
						discount_value_type: a.one_time_discount_value_type
					}
				}

				return {
					id: a.id,
					discount_value: 0,
					discount_value_type: 'PERCENTAGE'
				}
			});
		}

		function dispatchLineItems() {
			let cartPayload = blockAddOnState.value.map((a) => {
				return a.data.map(p => {
					let lineItem = {
						id: p.variant_id,
					};
					if (p.purchase_type === "SUBSCRIPTION") {
						lineItem.selling_plan = parseInt(p.selling_plan_id);
					}
					return lineItem;
				})
			}).flat();
			let hiddenProducts = blockHiddenAddOnState.value.map((p) => {
				return {
					id: p.id,
				};
			});
			cartPayload = [...cartPayload, ...hiddenProducts];
			ctx.emit('on-line-item-dispatch', cartPayload);
		}

		function handleBlockEnable(e) {
			if(!e.target.checked){				
				ctx.emit("on-block-unselect",null);
			}else{
				ctx.emit("on-block-select", props.block_data.id, props.block_data.add_to_cart_label, props.block_data.redirect_to_checkout, isOutOfStock.value);
			}
		}

		function handleAddOnDisabled(e) {
			blockAddOnState.value = blockAddOnState.value.map(a => {
				if (a.id === e.id) {
					return { ...e, data: [] };
				}
				return a;
			});
		}

		function handleAddOnSelect(e) {
			blockAddOnState.value = blockAddOnState.value.map(a => {
				if (a.id === e.id) {
					return e;
				}
				return a;
			});
		}

		function handeGiftAddOn(e) {
			blockAddOnState.value = blockAddOnState.value.map(a => {
				if (a.id === e.id) {
					return e;
				}
				return a;
			});
		}

		function handleAddOnUpdate(e) {
			blockAddOnState.value = blockAddOnState.value.map(a => {
				if (a.id === e.id) {
					return {
						...a,
						data: a.data.map(p => {
							if (p.variant_id === e.variant_id) {
								return {
									...p,
									purchase_type: e.purchase_type
								}
							}
							return p;
						})
					};
				}
				return a;
			});
		}

		return {
			doesSubAdnExist,
			blockAddOnState,
			blockHiddenAddOnState,
			headerBlockPrice,
			discountForMainProductFrmAdnArr,
			handleBlockEnable,
			formatMoneyy,
			calculateDiscountedPrice,
			handleAddOnDisabled,
			handleAddOnSelect,
			handleAddOnUpdate,
			handeGiftAddOn
		}
	},
	delimiters: ["${", "}"]
});

paymentOptionsApp.component('pb-lead-form', {
	template: "#leadFormBlock",
	emits: ["on-block-select", "on-lead-form-active","on-block-unselect"],
	props: ['block_data', 'block_active', 'is_preselected', 'input_type'],
	setup(props, ctx) {
		let cbPayload = {
			quantity: 1,
			id: props.block_data.affiliate_product?.id || 0
		}

		async function callbackFlow() {
			try {
				////console.log("called from outside of scope");
				if (props.block_data.callback_flow === "GO_TO_CHECKOUT") Rebuy.SmartCart.skip_open = true;
				if (props.block_data.submission_flow === 'SUBMISSION_W_MAIN_PRODUCT') {
					cbPayload.id = parseInt(document.querySelector(".product-form__buy-buttons input[name='id']").value);
				}
				await handleCbATC();
				if (props.block_data.callback_flow === "GO_TO_CHECKOUT") {
					let str = window.location.href.includes("/es/") ? "?locale=es" : "";
					str = "/checkout" + str;
					window.location.href = str;
				}
			} catch (error) {
				//console.log(error, "Error while adding to cart");
			} finally {
				return 1;
			}
		}

		onMounted(() => {

			if (props.block_data.payment_url && props.block_data.payment_url != '') {
				window.dynamicFormPaymentUrlOverride = props.block_data.payment_url;
			}

			if (props.block_data.submission_flow === 'SUBMISSION_W_MAIN_PRODUCT' || props.block_data.submission_flow === 'SUBMISSION_W_DUPLICATE_PRODUCT') {
				if (props.block_data.submission_flow === 'SUBMISSION_W_DUPLICATE_PRODUCT' && !props.block_data.affiliate_product) {
					throw new Error("Duplicate Affiliate product is not set bu the submission flow set to SUBMISSION_W_DUPLICATE_PRODUCT");
				}
				window.submissionCallBack = callbackFlow;
			}

			if (props.is_preselected) {
				////console.log(props.is_preselected,"preselected");
				handleBlockEnable();
			}

			document.addEventListener('variant:change', variantChangedHandler);

		});

		function variantChangedHandler(){
			if(props.block_active) handleMainProductPriceUpdate();
		};		  

		onUnmounted(()=>{
			document.removeEventListener('variant:change',variantChangedHandler);
		});

		function handleBlockEnable(e) {
			if(!e.target.checked){				
				ctx.emit("on-block-unselect",null);
			}else{
				ctx.emit("on-block-select", props.block_data.id, '', '', null);
			}
		}

		watch(() => props.block_active, () => {
			const defaultAddToCartBtn = document.getElementById('AddToCart');
			if (props.block_active) {
				ctx.emit('on-lead-form-active', false);
				// update the discount price in the top line.
				defaultAddToCartBtn.style.display = 'none';
				handleMainProductPriceUpdate();
			}
			else {
				defaultAddToCartBtn.style.display = 'block';
			}

		});

		function handleMainProductPriceUpdate(){
			const overideDiscount = parseFloat(props.block_data?.main_product_price_discount_overide) || 0;
			const salePrice = parseFloat(window.mainProductPrice.sale_price) || 0;
			let discountPrice = parseFloat(window.mainProductPrice.discount_price) || 0;
			let saveLabel = [formatSavingsLabel(window.mainProductPrice.savings)];
			if (overideDiscount) {
				discountPrice = calculateDiscountedPrice(salePrice, overideDiscount);
				saveLabel = [formatSavingsLabel(overideDiscount)];
			}
			updateMainProductLinePrice({ sale_price: salePrice, discount_price: discountPrice, savings: saveLabel }, props.block_data.type);
		}

		async function handleCbATC() {
			await fetch(window.Shopify.routes.root + "cart/add.js", {
				method: "POST",
				headers: {
					"Content-Type": "application/json",
				},
				body: JSON.stringify({ items: [cbPayload] }),
			}).then((resp) => resp.json());
		}

		return {
			handleBlockEnable,
			formatMoneyy,
			calculateDiscountedPrice
		}
	},
	delimiters: ["${", "}"]
});

paymentOptionsApp.component("gift-add-on-block", {
	template: "#giftAddonBlock",
	emits: ["on-gift-addon"],
	props: ["add_on"],
	setup(props, ctx) {
		const isSelected = ref(false);
		const selectedProduct = ref();
		const isAddOnEnabled = ref(false);

		onBeforeMount(() => {
			selectedProduct.value = props.add_on.product;
			isAddOnEnabled.value = true;
			ctx.emit("on-gift-addon", {
				id: props.add_on.id,
				data: [{ variant_id: selectedProduct.value.id }]
			});
		});

		return {
			selectedProduct,
			imgUrl
		}
	},
	delimiters: ["${", "}"]
});

paymentOptionsApp.component("add-on-block", {
	template: "#add-on-block",
	emits: ["on-addon-select", "on-addon-update", "on-addon-disabled"],
	props: ["add_on", "index", "block_data", "payment_options_data"],
	setup(props, ctx) {
		const isSelected = ref(false);
		const selectedProduct = ref([]);
		const dropdownOpen = ref(false);
		const isAddOnEnabled = ref(false);
		const filterOptions = ref(props.add_on.product_sets);
		const selectedFilter = ref('*');
		const filteredProductArr = ref(props.add_on.products);
		const searchString = ref('');
		const addonDropdownEl = ref(null);
		const mainProdPricing = ref(window.mainProductPrice);

		let purchaseOptions = [
			{
				type: "SUBSCRIPTION",
				label: "Monthly Subscription",
			},
			{
				type: "ONE_TIME",
				label: "One Time Purchase",
			},
		];
		purchaseOptions = purchaseOptions.filter(po=> po.type === props.add_on.purchase_type_option || props.add_on.purchase_type_option === 'BOTH');
		const activePurchaseType = ref(props.add_on.default_purchase_type);

    onMounted(() => {
      document.querySelector('.addon-selling-plan__option label')?.click();
    })

		onBeforeMount(() => {
			// props.add_on.products = props.add_on.products.map((p) => {	
			// 	return {
			// 		...p,
			// 		...{ og_selling_plan_id: getOGActiveSellingPlan(p.selling_plan_allocations, props.block_data.sale_price) },
			// 		...{ price_info: calculateDiscount(p, props.block_data.sale_price) }
			// 	};
			// });
			if (props.add_on.mandatory) {
				isAddOnEnabled.value = true;
				handeVariantSelect(props.add_on.products.find((p) => p.available === true));
			}
		});

		function toggleAddOnEnable() {
			isAddOnEnabled.value = !isAddOnEnabled.value;
			if (!isAddOnEnabled.value && selectedProduct.value.length) {
				ctx.emit("on-addon-disabled", { id: props.add_on.id });
				selectedProduct.value = [];
			}
			if (isAddOnEnabled.value) {
				handeVariantSelect(props.add_on.products[0])
			}
		}

		function handeVariantSelect(product) {
			// const addOnProductSku = document.getElementById('add-on-product-sku');
			// const addOnVariantTitle = document.getElementById('add-on-variant-title');
			// if (addOnProductSku && addOnVariantTitle) {
			//    ////console.log('set new sku', product)
			//   addOnProductSku.value = product.sku;
			//   addOnVariantTitle.value = product.name
			// }
			isAddOnEnabled.value = true
			selectedProduct.value = [product];
			if (props.add_on.purchase_type_option != "BOTH") {
				if (
					selectedProduct.value[0].selling_plan_allocations.length > 0 &&
					props.add_on.purchase_type_option === "SUBSCRIPTION"
				) {
					activePurchaseType.value = props.add_on.purchase_type_option;
				} else {
					activePurchaseType.value = "ONE_TIME";
				}
			} else {
				if (
					props.add_on.default_purchase_type === "SUBSCRIPTION" &&
					selectedProduct.value[0].selling_plan_allocations.length > 0
				) {
					activePurchaseType.value = props.add_on.default_purchase_type;
				} else {
					activePurchaseType.value = "ONE_TIME";
				}
			}
			////console.log(selectedProduct.value[0].selling_plan_allocations.length, "selling plan");
			if (!isSelected.value) isSelected.value = true;
			ctx.emit("on-addon-select", {
				id: props.add_on.id,
				data: selectedProduct.value.map(p => {
					return {
						variant_id: p.id,
						purchase_type: activePurchaseType.value,
						enable_discount: props.add_on.enable_discount,
						one_time_discount_value: props.add_on.one_time_discount_value,
						one_time_discount_value_type: props.add_on.one_time_discount_value_type,
						subscription_discount_value_type: props.add_on.subscription_discount_value_type,
						subscription_discount_value: props.add_on.subscription_discount_value,
						selling_plan_id: p.og_selling_plan_id,
						price_info: p.price_info,
						variant_title: p.name,
					}
				})
			});
			dropdownOpen.value = false;
		}

		function handleRadioCheck(product) {
			let checked = false;
			if (selectedProduct.value.length && selectedProduct.value[0].id === product.id) checked = true;
			return checked;
		}

		function toggleDropdown() {
			if (props.add_on.products.length > 1) {
				dropdownOpen.value = !dropdownOpen.value;
			}
		}

		function handlePurchasePlanSelect(type) {
			if (type === "SUBSCRIPTION" && selectedProduct.value[0].selling_plan_allocations.length > 0) {
				activePurchaseType.value = type;
			} else {
				activePurchaseType.value = "ONE_TIME";
			}
			ctx.emit("on-addon-update", {
				id: props.add_on.id,
				variant_id: selectedProduct.value[0].id,
				purchase_type: activePurchaseType.value
			});
		}

		function shouldRenderPurchaseOption(type) {
			if ((type === "SUBSCRIPTION" || type === "ANNUAL_PREPAID") && !selectedProduct.value[0].selling_plan_allocations.length) {
				return false;
			}
			return true;
		}

		function renderNoResults() {
			return searchString.value == '' ? "No products found" : `No products found for '${searchString.value}'`;
		}

		function resetSearchFilter() {
			searchString.value = '';
			resetSetFilter();
		}

		function handleSearch(e) {
			//console.log(e.target.value);
			searchString.value = e.target.value;
			if (searchString.value.length > 0) {
			  filteredProductArr.value = props.add_on.products.filter(p => {
				const regex = new RegExp(searchString.value, 'i');
				if (regex.test(p.name)) return p;
			  });
			} else {
			  handeFilterChange(selectedFilter.value);
			}
		}

		function resetSetFilter() {
			selectedFilter.value = '*';
			filteredProductArr.value = props.add_on.products;
			if(addonDropdownEl.value){
			  addonDropdownEl.value.scrollTo({
				top: 0,
			  });
			}
		}

		function handeFilterChange(e) {
			selectedFilter.value = e;
			filteredProductArr.value = props.add_on.products.filter(p => p.set_id.includes(e));
			if(selectedFilter.value === '*'){
			  filteredProductArr.value = props.add_on.products;
			}
			if (searchString.value.length > 0) {
			  filteredProductArr.value = filteredProductArr.value.filter(p => {
				const regex = new RegExp(searchString.value, 'i');
				if (regex.test(p.name)) return p;
			  });
			};
			addonDropdownEl.value.scrollTo({
			  top: 0,
			});
		}

		function handleChecked(id) {
			return id === selectedFilter.value;
		}

		function removeDecimal(value){
			return parseInt(value);
		}

		return {
			imgUrl,
			formatMoneyy,
			handeVariantSelect,
			toggleDropdown,
			handleRadioCheck,
			calculateDiscountedPrice,
			handlePurchasePlanSelect,
			toggleAddOnEnable,
			generatePaymentOptionLabels,
			shouldRenderPurchaseOption,
			handleSearch,
			resetSearchFilter,
			renderNoResults,
			handleChecked,
			handeFilterChange,
			resetSetFilter,
			removeDecimal,
			isSelected,
			addonDropdownEl,
			filterOptions,
			filteredProductArr,
			selectedProduct,
			dropdownOpen,
			selectedFilter,
			searchString,
			purchaseOptions,
			isAddOnEnabled,
			activePurchaseType,
			mainProdPricing
		};
	},
	delimiters: ["${", "}"],
});

paymentOptionsApp.component("subscription-benefit-block", {
	template: "#subscription-benefit-block",
	props: ["subs_benefit"],
	setup(props) { },
	delimiters: ["${", "}"],
});

paymentOptionsApp.component("build-a-plan", {
	template: "#buildAPlanBlock",
	emits: ["on-block-select", "on-lead-form-active", "on-block-unselect"],
	props: ['block_data', 'block_active', 'is_preselected', 'input_type'],
	setup(props, ctx) {

		watch(() => props.block_active, () => {
			if (props.block_active) {
				handleMainProductPriceUpdate();
			}
		});

		onMounted(() => {
			if (props.is_preselected) {
				////console.log(props.is_preselected,"preselected");
				handleBlockEnable()
			}
			document.addEventListener('variant:change', variantChangedHandler);
		});

		function variantChangedHandler(){
			if(props.block_active) handleMainProductPriceUpdate();
		};		  

		onUnmounted(()=>{
			document.removeEventListener('variant:change',variantChangedHandler);
		});	

		function handleMainProductPriceUpdate(){
			const overideDiscount = parseFloat(props.block_data?.main_product_price_discount_overide) || 0;
			const salePrice = parseFloat(window.mainProductPrice.sale_price) || 0;
			let discountPrice = parseFloat(window.mainProductPrice.discount_price) || 0;
			let saveLabel = [formatSavingsLabel(window.mainProductPrice.savings)];
			if (overideDiscount) {
				discountPrice = calculateDiscountedPrice(salePrice, overideDiscount);
				saveLabel = [formatSavingsLabel(overideDiscount)];
			}
			updateMainProductLinePrice({ sale_price: salePrice, discount_price: discountPrice, savings: saveLabel }, props.block_data.type);
		}

		function handleBlockEnable(e) {
			if(!e.target.checked){				
				ctx.emit("on-block-unselect",null);
			}else{
				ctx.emit("on-block-select", props.block_data.id, props.block_data.add_to_cart_label, '', null, props.block_data.landing_page);
			}
		}

		return {
			handleBlockEnable
		}

	},
	delimiters: ["${", "}"],
});

paymentOptionsApp.mount("#paymentBlocksApp");

function imgUrl(url, size) {
	// remove any current image size then add the new image size
	return url
		.replace(/_(pico|icon|thumb|small|compact|medium|large|grande|original|1024x1024|2048x2048|master)+\./g, ".")
		.replace(/\.jpg|\.png|\.gif|\.jpeg/g, function (match) {
			return "_" + size + match;
		});
}

function formatMoneyy(cents, format = "") {
	if (typeof cents === "string") {
		cents = cents.replace(".", "");
	}
	const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
		formatString = format || window.themeVariables.settings.moneyFormat;
	function defaultTo(value2, defaultValue) {
		return value2 == null || value2 !== value2 ? defaultValue : value2;
	}
	function formatWithDelimiterss(number, precision, thousands, decimal) {
		precision = defaultTo(precision, 2);
		thousands = defaultTo(thousands, ",");
		decimal = defaultTo(decimal, ".");
		if (isNaN(number) || number == null) {
			return 0;
		}
		number = roundNumber(number / 100, false, precision);
		let parts = number.split("."),
			dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands),
			centsAmount = parts[1] ? decimal + parts[1] : "";
		return dollarsAmount + centsAmount;
	}
	let value = "";
	switch (formatString.match(placeholderRegex)[1]) {
		case "amount":
			value = formatWithDelimiterss(cents, 2);
			break;
		case "amount_no_decimals":
			value = formatWithDelimiterss(cents, 0);
			break;
		case "amount_with_space_separator":
			value = formatWithDelimiterss(cents, 2, " ", ".");
			break;
		case "amount_with_comma_separator":
			value = formatWithDelimiterss(cents, 2, ".", ",");
			break;
		case "amount_with_apostrophe_separator":
			value = formatWithDelimiterss(cents, 2, "'", ".");
			break;
		case "amount_no_decimals_with_comma_separator":
			value = formatWithDelimiterss(cents, 0, ".", ",");
			break;
		case "amount_no_decimals_with_space_separator":
			value = formatWithDelimiterss(cents, 0, " ");
			break;
		case "amount_no_decimals_with_apostrophe_separator":
			value = formatWithDelimiterss(cents, 0, "'");
			break;
	}
	if (formatString.indexOf("with_comma_separator") !== -1) {
		return formatString.replace(placeholderRegex, value);
	} else {
		return formatString.replace(placeholderRegex, value);
	}
}

function roundNumber(num, savings, precision = 2) {
	if (isNaN(num)) {
		return;
	}

	let nummm = num.toFixed(3).split(".")[1].slice(2);
	if (nummm > 4 && !savings) {
		let number = Math.ceil((num + Number.EPSILON) * 100) / 100;
		return number.toFixed(precision);
	} else if (nummm < 6 && savings) {
		let number = Math.floor((num + Number.EPSILON) * 100) / 100;
		return number.toFixed(precision);
	} else {
		let number = Math.round((num + Number.EPSILON) * 100) / 100;
		return number.toFixed(precision);
	}
}

function calculateDiscountedPrice(salePrice = 0, discount = 0) {
	if (salePrice <= 0 || discount <= 0) {
		return null;
	}
	const discountAmount = (discount / 100) * salePrice;
	const discountedPrice = salePrice - discountAmount;

	return discountedPrice;
}

let digitalRounded = (Math.round(number / 100) / 10).toFixed(2);
let sale_price = formatMoneyy(window.mainProductPrice.sale_price)
let discount_price = parseInt((digitalRounded(window.mainProductPrice.discount_price)))
let savings = formatMoneyy(window.mainProductPrice.savings)



/**
 * Calculates the discounted prices for a product variant based on site-wide , collection and variant specific discounts.
 *
 * @param {Object} variant - The product variant object. *
 * @returns {Object} - The discounted prices and percentages for both one-time and subscription purchases.
 */
function calculateDiscount(variant, salePrice) {
	const isSiteWideDiscountEnabled = variant?.site_wide_discount || false;
	const siteWideDiscountValue = parseFloat(variant?.site_wide_discount_value) || 0;
	const isCollectionDiscountEnabled = variant?.collection_disc_check || false;
	const { collectionDiscount, prioritizeDiscount, discountAppliesTo, subscriptionOveride } = getMaxCollectionWideDiscount(variant.collections, variant.collection_disc_check);
	const variantSubsDiscountValue = parseFloat(variant?.variant_discount_subs) || 0;
	const variantOnetimeDiscountValue = parseFloat(variant?.variant_discount_one_time) || 0;
	const ogDiscount = parseFloat(variant?.og_discount) || 0;
	let doesCompareAtPriceExist = false;
	let variantSalePrice = variant.price;
	if (variant.compare_at_price > variant.price) {
		variantSalePrice = variant.compare_at_price;
		doesCompareAtPriceExist = true;
	}

	const productPriceObj = {
		price: variantSalePrice,
		SUBSCRIPTION: {
			discount_price: doesCompareAtPriceExist ? variant.price : 0,
			discount_percentage: doesCompareAtPriceExist ? (variant.price / variant.compare_at_price) * 100 : 0,
			og_discount: ogDiscount,
			_debug_log: ''
		},
		ONE_TIME: {
			discount_price: doesCompareAtPriceExist ? variant.price : 0,
			discount_percentage: doesCompareAtPriceExist ? (variant.price / variant.compare_at_price) * 100 : 0,
			_debug_log: ''
		}
	};

	if (isSiteWideDiscountEnabled && siteWideDiscountValue) {
		productPriceObj.ONE_TIME.discount_price = calculateDiscountedPrice(variantSalePrice, siteWideDiscountValue);
		productPriceObj.ONE_TIME.discount_percentage = siteWideDiscountValue;
		productPriceObj.ONE_TIME._debug_log = `Applying sitewide discount  of ${siteWideDiscountValue}`;
		productPriceObj.SUBSCRIPTION.discount_price = calculateDiscountedPrice(variantSalePrice, siteWideDiscountValue);
		productPriceObj.SUBSCRIPTION.discount_percentage = siteWideDiscountValue;
		productPriceObj.SUBSCRIPTION._debug_log = `Applying sitewide discount  of ${siteWideDiscountValue}`;
	}

	if (isCollectionDiscountEnabled && collectionDiscount) {
		const subscriptionDiscount = subscriptionOveride || collectionDiscount;
		// reset before setting collection discounts
		productPriceObj.ONE_TIME.discount_price = 0;
		productPriceObj.ONE_TIME.discount_percentage = 0;
		productPriceObj.SUBSCRIPTION.discount_price = 0;
		productPriceObj.SUBSCRIPTION.discount_percentage = 0;

		// if set true ignores site-wide
		if (prioritizeDiscount) {
			// subscription overide will always overide regardless of discountAppliesTo
			if (subscriptionOveride) {
				productPriceObj.SUBSCRIPTION.discount_price = calculateDiscountedPrice(variantSalePrice, subscriptionDiscount);
				productPriceObj.SUBSCRIPTION.discount_percentage = subscriptionDiscount;
				productPriceObj.SUBSCRIPTION._debug_log = `Applying collection priority discount ${subscriptionDiscount}`;
			}

			if (discountAppliesTo === 'One-time' || discountAppliesTo === 'One-time and Subscription') {
				productPriceObj.ONE_TIME.discount_price = calculateDiscountedPrice(variantSalePrice, collectionDiscount);
				productPriceObj.ONE_TIME.discount_percentage = collectionDiscount;
				productPriceObj.ONE_TIME._debug_log = `Applying collection priority discount ${collectionDiscount}`;
			}

			if (discountAppliesTo === 'Subscription' || discountAppliesTo === 'One-time and Subscription') {
				productPriceObj.SUBSCRIPTION.discount_price = calculateDiscountedPrice(variantSalePrice, subscriptionDiscount);
				productPriceObj.SUBSCRIPTION.discount_percentage = subscriptionDiscount;
				productPriceObj.SUBSCRIPTION._debug_log = `Applying collection priority discount ${subscriptionDiscount}`;
			}
		} else {
			// if collection discount is not prioritized compare site wide and collection wide discount and apply which one is greater
			if (siteWideDiscountValue >= collectionDiscount && isSiteWideDiscountEnabled) {
				productPriceObj.ONE_TIME.discount_price = calculateDiscountedPrice(variantSalePrice, siteWideDiscountValue);
				productPriceObj.ONE_TIME.discount_percentage = siteWideDiscountValue;
				productPriceObj.ONE_TIME._debug_log = `Applying sitewide discount  of ${siteWideDiscountValue}`;
				productPriceObj.SUBSCRIPTION.discount_price = calculateDiscountedPrice(variantSalePrice, siteWideDiscountValue);
				productPriceObj.SUBSCRIPTION.discount_percentage = siteWideDiscountValue;
				productPriceObj.SUBSCRIPTION._debug_log = `Applying sitewide discount  of ${siteWideDiscountValue}`;
			} else {
				// subscription overide will always overide regardless of discountAppliesTo
				if (subscriptionOveride) {
					productPriceObj.SUBSCRIPTION.discount_price = calculateDiscountedPrice(variantSalePrice, subscriptionOveride);
					productPriceObj.SUBSCRIPTION.discount_percentage = subscriptionOveride;
					productPriceObj.SUBSCRIPTION._debug_log = `Applying collection discount ${subscriptionOveride}`;
				}

				if (discountAppliesTo === 'One-time' || discountAppliesTo === 'One-time and Subscription') {
					productPriceObj.ONE_TIME.discount_price = calculateDiscountedPrice(variantSalePrice, collectionDiscount);
					productPriceObj.ONE_TIME.discount_percentage = collectionDiscount;
					productPriceObj.ONE_TIME._debug_log = `Applying collection discount ${collectionDiscount}`;
				}

				if (discountAppliesTo === 'Subscription' || discountAppliesTo === 'One-time and Subscription') {
					productPriceObj.SUBSCRIPTION.discount_price = calculateDiscountedPrice(variantSalePrice, subscriptionDiscount);
					productPriceObj.SUBSCRIPTION.discount_percentage = subscriptionDiscount;
					productPriceObj.SUBSCRIPTION._debug_log = `Applying collection discount ${subscriptionDiscount}`;
				}
			}
		}
	}

	// variant level discounts gets the highest priority
	if (variantOnetimeDiscountValue) {
		productPriceObj.ONE_TIME.discount_price = calculateDiscountedPrice(variantSalePrice, variantOnetimeDiscountValue);
		productPriceObj.ONE_TIME.discount_percentage = variantOnetimeDiscountValue;
		productPriceObj.SUBSCRIPTION._debug_log = `Applying Variant discount ${variantOnetimeDiscountValue}`;
	}

	if (variantSubsDiscountValue) {
		productPriceObj.SUBSCRIPTION.discount_price = calculateDiscountedPrice(variantSalePrice, variantSubsDiscountValue);
		productPriceObj.SUBSCRIPTION.discount_percentage = variantSubsDiscountValue;
		productPriceObj.SUBSCRIPTION._debug_log = `Applying Variant discount ${variantSubsDiscountValue}`;
	}


	if(salePrice == "100.0") {
		productPriceObj.SUBSCRIPTION.discount_price = calculateDiscountedPrice(variantSalePrice, 0);
		productPriceObj.SUBSCRIPTION.discount_percentage = 0;
		productPriceObj.SUBSCRIPTION._debug_log = `Applying Variant discount for free with subs block`;
	}

	// remove debug logs
	if (false) {
		delete productPriceObj.SUBSCRIPTION._debug_log;
		delete productPriceObj.ONE_TIME._debug_log;
	}

	return productPriceObj;
}



/**
 * Checks if there are any selling plans.
 *
 * This function takes an array of selling plans and returns a boolean
 * indicating whether there are any plans present.
 *
 * @param {Array} plans - An array of selling plans.
 * @returns {boolean} True if there are selling plans, false otherwise.
 */
function checkSellingPlans(plans) {
	return plans && plans.length ? true : false;
}



/**
 * Gets the maximum value discount information for a collection.
 * @param {Array<Object>} collections - The array of collection objects.
 * @param {boolean} enableCollectionDiscount - Flag to enable collection discount.
 * @returns {Object} - An object containing collection discount information.
 */
function getMaxCollectionWideDiscount(collections = [], enableCollectionDiscount) {
	if (!collections || !collections.length || !enableCollectionDiscount) {
		return {
			collectionDiscount: 0,
			prioritizeDiscount: false,
			discountAppliesTo: 'One-time and Subscription',
			subscriptionOveride: 0
		};
	}

	const collectionDiscountMetafields = collections.filter(c => {
		if (c.metafields && c.metafields.hasOwnProperty('collection_discount')) {
			return c;
		}
	}).map(c => {
		return { ...c.metafields, collection_discount: parseFloat(c.metafields.collection_discount) }
	}).sort((a, b) => b.collection_discount - a.collection_discount);

	if (collectionDiscountMetafields && collectionDiscountMetafields.length) {
		const currentCollectionDiscount = collectionDiscountMetafields[0];
		return {
			collectionDiscount: currentCollectionDiscount.collection_discount,
			prioritizeDiscount: currentCollectionDiscount?.prioritize_discount || false,
			discountAppliesTo: currentCollectionDiscount?.discount_applies_to[0] || 'One-time and Subscription',
			subscriptionOveride: parseFloat(currentCollectionDiscount?.subscription_discount_override) || 0,
		}
	}

	return {
		collectionDiscount: 0,
		prioritizeDiscount: false,
		discountAppliesTo: 'One-time and Subscription',
		subscriptionOveride: 0
	};
}


/**
 * The function `generatePaymentOptionLabels` generates labels for payment options based on the
 * selected product and active purchase type.
 * @param {Array<Object>} selectedProduct - selectedProduct is an array containing information about the product
 * selected by the user. It seems to contain details such as product metadata, price information, and
 * discount percentages for different purchase types. The function generates payment option labels
 * based on the selected product and active purchase type.
 * @param {string} activePurchaseType - The function `generatePaymentOptionLabels` takes two parameters:
 * `selectedProduct` and `activePurchaseType`. The `selectedProduct` parameter is an array containing
 * the selected product, and the `activePurchaseType` parameter specifies the type of purchase (e.g.,
 * 'ONE_TIME' or 'RE
 * @returns {string} - An string which represents the label based on conditions selected
 */
function generatePaymentOptionLabels(selectedProduct, activePurchaseType) {
	let product = selectedProduct[0];

	// Validate product and necessary properties
	if (!product || !product.price_info || !product.price_info[activePurchaseType]) {
		return '';
	}

	if (activePurchaseType === 'ONE_TIME') {
		// Product card label metafields take highest priority
		if (product.main_product && product.main_product.product_metafield_label) {
			return product.main_product.product_metafield_label.map(label => label.title).join(' ');
		}

		let discountPercentage = product.price_info[activePurchaseType].discount_percentage;
		if (discountPercentage && discountPercentage != 0) {
			return `${discountPercentage}% Off`;
		}

	} else if (activePurchaseType === 'SUBSCRIPTION') {
		let labelStr = '';
		let saleDiscount = product.price_info[activePurchaseType].discount_percentage;
		let ogDiscount = product.price_info[activePurchaseType].og_discount;

		if (saleDiscount > 0) {
			labelStr = `${saleDiscount}% off now`;
		}

		if (ogDiscount && ogDiscount === saleDiscount) {
			labelStr = `${saleDiscount}% off now and on future orders`;
		} else if (ogDiscount && saleDiscount && ogDiscount != saleDiscount) {
			labelStr = `${saleDiscount}% off now, ${ogDiscount}% off on future orders`;
		} else if (saleDiscount <= 0 && ogDiscount) {
			labelStr = `${ogDiscount}% off on future orders`;
		}

		return labelStr;
	}

	return '';
}

/**
 * Extracts the numerical value from a string containing a currency symbol.
 *
 * @param {string} currencyString - The string containing the currency value.
 * @returns {number} - The extracted numerical value as a whole number after multiplying by 100.
 */
function extractNumber(currencyString) {
	const numberString = currencyString.replace(/[^\d.-]/g, '');
	const number = parseFloat(numberString);
	return Math.round(number * 100);
}


/**
 * @typedef {Object} AddonDiscount
 * @property {string} id - The unique identifier for the discount.
 * @property {number} discount_value - The value of the discount.
 * @property {string} discount_value_type - The type of the discount, either "FIXED" or "PERCENTAGE".
 */

/**
 * Calculates the total discount percentage from an array of discount objects.
 * Fixed discount values are converted into percentages based on the base price.
 *
 * @param {AddonDiscount[]} discounts - The array of discount objects.
 * @param {number} basePrice - The base price to which fixed discounts are converted into percentages.
 * @returns {number} The total discount percentage.
 */
function calculateTotalAdnDiscount(discounts, basePrice) {
	let totalDiscountPercentage = 0;

	discounts.forEach(discount => {
		if (discount.discount_value_type === 'FIXED') {
			// Convert fixed discount to percentage
			const percentage = (discount.discount_value * 100 / basePrice) * 100;
			totalDiscountPercentage += percentage;
		} else if (discount.discount_value_type === 'PERCENTAGE') {
			totalDiscountPercentage += discount.discount_value;
		}
	});

	return totalDiscountPercentage;
}

/**
 * Returns sum of the saleprice and discount price for the given addon array
 * @param {any[]} addOns 
 */
function getTotalAddonPrice(addOns) {
	let totalSalePrice = 0;
	let totalDiscountPrice = 0;
	addOns.forEach(a => {
		if (a.data.length) {
			if(a.data[0].price_info){
				totalSalePrice += a.data[0].price_info.price;
				if (a.data[0].price_info[a.data[0].purchase_type].discount_price) {
					totalDiscountPrice += a.data[0].price_info[a.data[0].purchase_type].discount_price;
				}
			}
			
		}
	});
	return { totalSalePrice, totalDiscountPrice }
}

/**
 * This function updates the price and save labels according to the selected payment blocks
 * @param {object} headerBlock - price into state of the header block will be used to update the topline price
 * @param {string} blockType - block type of the current payment block 
 */
function updateMainProductLinePrice(headerBlock, blockType) {
	//console.log(headerBlock,"header block");
	const priceWrapEl = document.querySelector('.price-list.prive_price-list');
	const stickyPriceWrapEl = document.querySelector('.product-sticky-form__info .price-list')
	const saveLabelsWrapEl = document.querySelector('.product-meta__label-list.prive-label-list');
	priceWrapEl.innerHTML = '';
	
	saveLabelsWrapEl.innerHTML = '';
	////console.log(headerBlock,"header block");
	if (priceWrapEl) {
		const priceElement = document.createElement('span');
		priceElement.classList.add('prive_price', 'price--large');
		priceElement.id = 'prive_price_elem';
		priceElement.innerHTML = headerBlock.discount_price != null ? `<span class="visually-hidden visually-hidden--inline">Regular Price</span><s>${formatMoneyy(headerBlock.sale_price)}</s>` : ` <span class="visually-hidden visually-hidden--inline">Regular Price</span>${formatMoneyy(headerBlock.sale_price)}`;
		//stickyPriceWrapEl.appendChild(priceElement);

		if (headerBlock.discount_price != null) {
			const salePriceElement = document.createElement('span');
			salePriceElement.classList.add('sale_price', 'price--large');
			salePriceElement.innerHTML = ` <span class="visually-hidden visually-hidden--inline">Sale Price</span>${formatMoneyy(headerBlock.discount_price)}`;
			priceWrapEl.appendChild(salePriceElement);
			//stickyPriceWrapEl.appendChild(salePriceElement);
		}
		priceWrapEl.appendChild(priceElement);
	}

	// logics for sticky product add to cart
	if (stickyPriceWrapEl) {
		stickyPriceWrapEl.innerHTML = '';
		const priceElement = document.createElement('span');
		priceElement.classList.add('product-sticky-form__price');
		priceElement.innerHTML = headerBlock.discount_price != null ? `<span class="visually-hidden visually-hidden--inline">Regular Price</span><s>${formatMoneyy(headerBlock.sale_price)}</s>` : `<span class="visually-hidden visually-hidden--inline">Regular Price</span>${formatMoneyy(headerBlock.sale_price)}`;
		stickyPriceWrapEl.appendChild(priceElement);

		if (headerBlock.discount_price != null) {
			const salePriceElement = document.createElement('span');
			salePriceElement.classList.add('sticky-sale-price');
			salePriceElement.style.color = 'red';
			salePriceElement.innerHTML = ` <span class="visually-hidden visually-hidden--inline">Sale Price</span>${formatMoneyy(headerBlock.discount_price)}`;
			stickyPriceWrapEl.appendChild(salePriceElement);
		}
	}

	if (saveLabelsWrapEl && headerBlock.savings) {
		savingsArr = Array.isArray(headerBlock.savings) ? headerBlock.savings : [formatSavingsLabel(headerBlock.savings)];
		savingsArr.forEach(s => {
			if (s) {
				const savingsLblEl = document.createElement('span');
				savingsLblEl.classList.add('label', 'label--highlight');
				savingsLblEl.innerHTML = s;
				saveLabelsWrapEl.appendChild(savingsLblEl);
			}
		});
	}

}


/**
 * Generates a savings message based on the provided savings value.
 * 
 * @param {number|string} savings - The savings value, which could be a percentage or a dollar amount.
 * @returns {string|null} The savings message if savings is provided and greater than 0, otherwise null.
 */
function formatSavingsLabel(savings) {
    if (!savings) return null;
    if (!isNaN(savings)) savings = savings.toFixed(2);
    // Remove the decimal part if it's .00
    const savingsStr = savings.toString().replace(/\.00$/, '').trim();
    const hasPercentageOrDollar = /[%$]/.test(savingsStr);
    return hasPercentageOrDollar ? `${savingsStr} OFF` : `${parseInt(savingsStr)}% OFF`;
}


/**
 * Generates a savings label for addons along with main product.
 * 
 * @param {string[]} labelArr - reff of current savings label array.
 * @param {any[]} addonBlockArr - reff of currently active addon block array
 * @returns {string[]} - modified savings label array with newly added labels.
 */
function getSavingsLabelForAddons(labelArr = [], addonBlockArr = []) {
	addonBlockArr.forEach(block => {
		if (block.data[0]) {
			const selectedPurchaseType = block.data[0].purchase_type;
			const productTitle = block.data[0].variant_title;
			const discountValue = block.data[0].price_info ? block.data[0].price_info[selectedPurchaseType].discount_percentage : 0;
			if (discountValue) {
				labelArr.push(`${parseInt(discountValue)}% OFF ${productTitle}`);
			}
		}
	});

	return labelArr;
}

/**
 * Gets the additional promo labels or secondary price line from addon blocks
 * @param {string[]} labelArr - reff of current savings label array.
 * @param {any[]} addonBlockArr - reff of currently active addon block array
 * @param {object} blockData - reff of current blockdata object
 * @returns {string[]} - modified savings label array with newly added labels.
 */
function renderAdditionalPromoLabelOrPrice(labelArr = [], addonBlockArr = [], blockData) {
	addonBlockArr.forEach((block) => {
		const currentSelectedBlockData = blockData.add_ons.find((b) => b.id === block.id);
		let additionalPromoTag = currentSelectedBlockData.additional_promo_save_tag || null;
		const defaultPurchaseType = currentSelectedBlockData.default_purchase_type;
		if (block.data[0]) {
			const currentAddon = block.data[0];
			const selectedPurchaseType = currentAddon.purchase_type;
			if (additionalPromoTag && selectedPurchaseType != defaultPurchaseType) {
				if (!currentSelectedBlockData?.render_promo_tag_as || currentSelectedBlockData.render_promo_tag_as === "LABEL") {
					labelArr.push(additionalPromoTag);
				} else if (currentSelectedBlockData.render_promo_tag_as === "PRICE_LINE") {
					clearSecondaryPriceLine();
					let discountValue = parseFloat(currentSelectedBlockData.subscription_discount_value);

					if (defaultPurchaseType === "ONE_TIME") {
						discountValue = parseFloat(currentSelectedBlockData.one_time_discount_value);
					}
					let mainProductMSRP = window.mainProductPrice.sale_price;
					let salePrice = calculateDiscountedPrice(mainProductMSRP, discountValue);
					let mainPriceLineEl = document.querySelector(".prive_product-meta__price-list-container");
					let secondaryPriceLineEl = document.createElement("div");
					secondaryPriceLineEl.classList.add("secondary-price");
					secondaryPriceLineEl.setAttribute("id", "secondaryPriceLine");
					let priceElStr = ``;

					if (
						blockData.price_render_mode === "DISPLAY_COMBINED_PRICE_W_DISCOUNT" ||
						blockData.price_render_mode === "DISPLAY_COMBINED_PRICE"
					) {
						let addOnMsrpPrice = currentAddon.price_info.price;
						let addOnSalePrice = currentAddon.price_info[defaultPurchaseType].discount_price;
						mainProductMSRP += addOnMsrpPrice;
						salePrice += addOnSalePrice;
						discountValue = calculateDiscountPercentage(mainProductMSRP, salePrice);
					}

					if (mainProductMSRP) {
						priceElStr += `<span class="secondary-price__msrp-price ${salePrice ? "has-sale" : ""}">${formatMoneyy(
							mainProductMSRP
						)}</span>`;
					}
					if (salePrice) {
						priceElStr += `<span class="secondary-price__sale-price">${formatMoneyy(salePrice)}</span>`;
					}

					additionalPromoTag = additionalPromoTag.replace("${price}", priceElStr);

					if (discountValue) {
						const discountTagEl = `<span class="label label--highlight product-thumbnail_badge case-1">SAVE ${parseInt(discountValue)}%</span>`;
						additionalPromoTag = additionalPromoTag.replace("${discount_per}", discountTagEl);
					}else {
						additionalPromoTag = additionalPromoTag.replace("${discount_per}", '');
					}

					secondaryPriceLineEl.innerHTML = additionalPromoTag;

					if (mainPriceLineEl) {
						mainPriceLineEl.insertAdjacentElement("afterend", secondaryPriceLineEl);
					}
				}
			} else {
				clearSecondaryPriceLine();
			}
		}
	});
	return labelArr;
}

/**
 * Renders the additional tag on the initial mount cycle from the 1st available pay in full block
 * @param {any[]} blocks - reff of payment blocks array
 * @returns {void}
 */
function renderAdditionalTagOrPriceOnMount(blocks) {
	const saveLabelsWrapEl = document.querySelector(".product-meta__label-list.prive-label-list");
	const firstPayInFullBlock = blocks.find((b) => b.type === "pay_in_full");
	if (!firstPayInFullBlock) return;
	firstPayInFullBlock.add_ons.forEach((a) => {
		const defaultPurchaseType = a.default_purchase_type;
		let additionalPromoTag = a?.additional_promo_save_tag;
		let discountValue = parseFloat(a.subscription_discount_value);
    //console.log(defaultPurchaseType, "default purchase type");
		if (defaultPurchaseType === "ONE_TIME") {
			discountValue = parseFloat(a.one_time_discount_value);
		}
    //console.log(a?.render_promo_tag_as, additionalPromoTag,"asdasdasdasdasdasdsa");
		if (a?.render_promo_tag_as === "LABEL" && additionalPromoTag) {
			if (additionalPromoTag && discountValue) {
				const savingsLblEl = document.createElement("span");
				savingsLblEl.classList.add("label", "label--highlight");
				savingsLblEl.innerHTML = additionalPromoTag;
				saveLabelsWrapEl.appendChild(savingsLblEl);
			}
    } else if (a?.render_promo_tag_as === "PRICE_LINE" && additionalPromoTag) {
			clearSecondaryPriceLine();
			let mainProductMSRP = window.mainProductPrice.sale_price;
			let salePrice = calculateDiscountedPrice(mainProductMSRP, discountValue);
			let mainPriceLineEl = document.querySelector(".prive_product-meta__price-list-container");
			let secondaryPriceLineEl = document.createElement("div");
			secondaryPriceLineEl.classList.add("secondary-price");
			secondaryPriceLineEl.setAttribute("id", "secondaryPriceLine");
			let priceElStr = ``;

			if (mainProductMSRP) {
				priceElStr += `<span class="secondary-price__msrp-price ${salePrice ? "has-sale" : ""}">${formatMoneyy(
					mainProductMSRP
				)}</span>`;
			}
			if (salePrice) {
				priceElStr += `<span class="secondary-price__sale-price">${formatMoneyy(salePrice)}</span>`;
			}

			additionalPromoTag = additionalPromoTag.replace("${price}", priceElStr);

			if (discountValue) {
				const discountTagEl = `<span class="label label--highlight product-thumbnail_badge case-1">SAVE ${parseInt(discountValue)}%</span>`;
				additionalPromoTag = additionalPromoTag.replace("${discount_per}", discountTagEl);
			}else {
				additionalPromoTag = additionalPromoTag.replace("${discount_per}", '');
			}

			secondaryPriceLineEl.innerHTML = additionalPromoTag;

			if (mainPriceLineEl) {
				mainPriceLineEl.insertAdjacentElement("afterend", secondaryPriceLineEl);
			}
		}
	});
}

function clearSecondaryPriceLine() {
	const existingSecondaryPriceLineEl = document.querySelector("#secondaryPriceLine");
	if (existingSecondaryPriceLineEl) {
		existingSecondaryPriceLineEl.remove();
	}
}

/**
 * Compares the user location with blacklist and returns false if the location is part of the black list
 * @param {string[]} blacklist
 * @returns {boolean} 
 */
function shouldRenderBlock(blacklist = []){	
	const urlSfx = window.location.hostname.split('.').pop();

	if(urlSfx && urlSfx != 'com'){
		if(blacklist.includes('International')) return false;
		if(urlSfx.toUpperCase() === currentGeoloc.country_code && blacklist.includes(currentGeoloc.country_name)) return false;
	}

	if(currentGeoloc.country_name != 'United States' && blacklist.includes('International')){
		return false;
	}

	if(blacklist.includes(currentGeoloc.country_name)){
		return false;
	}

	return true;
}

/**
 * Calculates the discount percentage based on the sale price and offer price.
 *
 * @param {number} salePrice - The original sale price of the item.
 * @param {number} offerPrice - The discounted offer price of the item.
 * @returns {number|null} - The integer part of the discount value, or null if inputs are invalid.
 */
function calculateDiscountPercentage(salePrice, offerPrice) {
	if (
	  typeof salePrice !== 'number' ||
	  typeof offerPrice !== 'number' ||
	  salePrice <= 0 ||
	  offerPrice < 0 ||
	  offerPrice > salePrice
	) {
	  return null;
	}
	const discount = ((salePrice - offerPrice) / salePrice) * 100;
	return Math.floor(discount);
}